import styled from 'styled-components/native';

import { Header } from 'components/app-header/mobile-header/styled';

export const SignUpHeader = styled(Header)`
  background-color: ${({ theme }) => theme.token('background-default')};
`;

// Padding grows the 24px icon to a 44px touch target; the negative margin keeps
// the icon where the header lays it out.
export const BackArrowContainer = styled.Pressable`
  padding: 10px;
  margin: -10px;
`;
